<template>
  <div class="bg-avatar">
    <div class="d-flex align-items-center justify-content-center position-relative" :class="avatarBgClass()"
      :style="avatarBox()">
      <div v-if="avatar === null" style="color: #FFF;">{{ initial }}</div>
      <img v-else :src="avatar" alt="avatar" :style="avatarThumb()">
      <div v-if="isCompany"
        class="position-absolute bg-white rounded-circle d-flex justify-content-center align-items-center"
        style="height: 1rem; width: 1rem; right: -0.5px; bottom: -0.5px">
        <v-icon :size="10" color="rgba(63, 63, 63, 1)">mdi-domain</v-icon>
      </div>
    </div>
  </div>

</template>

<script>
export default {
  props: {
    user: {
      required: false,
      default: function () {
        return { first_name: null, last_name: null, avatar_url: null, avatar_color: null, role: null, initials: null }
      }
    },
    staticColor: { type: String, required: false, default: null },
    avatarUrl: { type: String, required: false, default: null },
    role: { type: String, required: false, default: null },
    fullName: { typs: String, required: false, default: null },
    firstName: { typs: String, required: false, default: null },
    lastName: { type: String, required: false, default: null },
    size: { type: Number, required: false, default: 30 },
    isCompany: { type: Boolean, required: false, default: false }
  },
  data: function () {
    return {
    }
  },
  computed: {
    avatar() {
      if (this.user.avatar_url) return this.user.avatar_url
      else if (this.avatarUrl) return this.avatarUrl
      else return null
    },
    initial() {
      if (this.user.initials) return this.user.initials
      else if (this.user.first_name && this.user.last_name) return (this.user.first_name.charAt(0) + this.user.last_name.charAt(0)).toUpperCase()
      else if (this.fullName) {
        let name = this.fullName.split(" ")
        return (name[0].charAt(0) + name[name.length - 1].charAt(0)).toUpperCase()
      } else if (this.firstName && this.lastName) return (this.firstName.charAt(0) + this.lastName.charAt(0)).toUpperCase()
      else return ''
    }
  },
  methods: {
    avatarBgClass() {
      let className = 'guest'
      if (this.user.role == 'super_admin' || this.role == 'super_admin') className = 'super-admin'
      else if (this.user.role == 'institution_admin' || this.role == 'institution_admin') className = 'admin-institution'
      else if (this.user.role == 'admin' || this.role == 'admin') className = 'admin'
      else if (this.user.role == 'staff' || this.role == 'staff') className = 'staff'
      else if (this.role == 'user' || this.role == 'company' || this.user.role == 'user' ) {
        if (this.user.client_status === 'active') {
          className = 'active'
        } else if (this.user.client_status === 'archived') {
          className = 'archived'
        } else if (this.user.client_status === 'merged') {
          className = 'merged'
        }
      }
      return className
    },
    avatarBox() {
      let styleColor = ''
      if(this.staticColor){
       styleColor =  'background-color:' + this.staticColor + ';'
      }
      let n = Number(this.size)
      return 'width:' + n + 'px; height:' + n + 'px; line-height:' + n + 'px; font-size:' + (n / 2.2) + 'px; border-radius:' + (n / 6) + 'px ;font-weight:900; overflow:hidden;'+styleColor
    },
    avatarThumb() {
      let n = Number(this.size)
      return 'width:100%; height:auto; min-width:' + n + 'px; min-height:' + n + 'px; border-radius:' + (n / 6)
    }
  },
}
</script>
